<template>
<body>
  <form class="modalContainer active loginModal formsModal">
    <div class="actualModal">
      <router-link to="/index" class="closeModal"><i class="fal fa-times"></i></router-link>
      <div class="modalBodyOfItem">
        <form @submit.prevent="handleSubmit" class="itemBodyLeftModal">
          <h4>Reset Password</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>New Password</h5>
              <input v-model="password" type="password" id="pw" placeholder="*******************" />
            </div>
            <div class="individualInput">
              <h5>Confirm Password</h5>
              <input v-model="confirmPassword" type="password" id="password" placeholder="*******************" />
            </div>
          </div>
          <div class="mobileFlex"></div>
          <div class="quickCheckout">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please complete the form.
            </div>
            <button type="submit">{{buttonText}}</button>
          </div>
          <!--<div class="formBtm">
            <router-link to="/signup" class="signUpBtn">Don't have an account? Sign up</router-link>
          </div> -->
        </form>
      </div>
    </div>
  </form>
</body>
</template>

<script>
import {userService} from '@/services/user'
export default {
  name: 'login',
  data() {
    return {
      haserrors: false,
      email: '',
      password: '',
      confirmPassword: '',
      buttonText: 'Reset',
    }
  },
  computed: {
    hash() {
      return this.$route.params.hash
    }
  },
  methods: {
    handleSubmit(e) {
      const { hash, password, confirmPassword } = this
      if (!hash || !password || password != confirmPassword) return this.haserrors = true
      if (password.length < 8) return this.haserrors = true
      userService.resetPassword(hash, password, confirmPassword)
        .then((resp) => {
          if (resp.success) {
            console.log(`reset success!`)
            this.buttonText = 'Saved!'
            setTimeout(() => {
              this.$router.push('/login')
            },1500)

          } else {
            this.haserrors = true
          }
        })
        .catch(err => {
          console.error(err)
          this.haserrors = true
        })

    }
  }

}
</script>
